export default __webpack_public_path__ + "static/Survive-Japan-Knowing-Only-English-translations-41c848c630f3b09270e48126baa13da2.jpg";